import type { ReactNode } from 'react'

import { isWebView } from '@fourthwall/utils'

type WebViewRemoverProps = {
  children: ReactNode
}

export const WebViewRemover = ({ children }: WebViewRemoverProps) => {
  return isWebView() ? null : children
}
